import axios from "axios";
import { RunConfigService, ConfigService } from "@nuskin/ns-util";

export default {
  getTopNavigation
};

/**
 * Used to retrieve top nav data from service
 * @returns Promise<data>
 */
async function getTopNavigation() {
  const marketConfig = ConfigService.getMarketConfig();
  const runConfig = RunConfigService.getRunConfig();
  const topNavigationUrl =
    `${marketConfig.siteUrl}` +
    `/apps/hello/services/markettopnavigation.` +
    `${runConfig.language}_${runConfig.country}.json"`;
  const topNavData = await axios.request({
    method: "get",
    url: topNavigationUrl,
    responseType: "json"
  });

  return topNavData.data;
}
